import React, { Component } from 'react';
import './App.css';
import marked from 'marked';
import highlight from 'highlight.js';

marked.setOptions({
  gfm: true,
  tables: true,
  breaks: true,
  highlight: function(code) {
    return highlight.highlightAuto(code).value;
  }
});

const renderer = new marked.Renderer();
renderer.link = function(href, title, text) {
  return `<a href="${href}" title="${title}" target=_blank >${text}</a>`;
};

const defaultMarkdown = `# Welcome to my React Markdown Previewer!

## This is a sub-heading...
### And here's some other cool stuff:

Heres some code, \`<div></div>\`, between 2 backticks.

\`\`\`javascript
// this is multi-line code:

function anotherExample(firstLine, lastLine) {
  if (firstLine == '\`\`\`' && lastLine == '\`\`\`') {
    return multiLineCode;
  }
}
\`\`\`

You can also make text **bold**... whoa!
Or _italic_.
Or... wait for it... **_both!_**
And feel free to go crazy ~~crossing stuff out~~.

There's also [links](https://www.freecodecamp.com), and
> Block Quotes!

And if you want to get really crazy, even tables:

Wild Header | Crazy Header | Another Header?
------------ | ------------- | -------------
Your content can | be here, and it | can be here....
And here. | Okay. | I think we get it.

- And of course there are lists.
  - Some are bulleted.
     - With different indentation levels.
        - That look like this.

1. And there are numbererd lists too.
1. Use just 1s if you want!
1. But the list goes on...
- Even if you use dashes or asterisks.
* And last but not least, let's not forget embedded images:

![React Logo w/ Text](https://goo.gl/Umyytc)
`;

class Editor extends Component {
  render() {
    let classes = ['editorWrapper'];
    if (this.props.maximize) {
      classes.push('maximized');
    }
    return (
      <div className={classes.join(' ')}>
        <TitleBar
          title="Editor"
          maximize={this.props.maximize}
          onClick={this.props.handleClick}
        />
        <textarea
          id="editor"
          value={this.props.input}
          onChange={e => {
            this.props.handleChange(e.target.value);
          }}
        />
      </div>
    );
  }
}

class Previewer extends Component {
  render() {
    let classes = ['previewerWrapper'];
    if (this.props.maximize) {
      classes.push('maximized');
    }
    return (
      <div className={classes.join(' ')}>
        <TitleBar
          title="Preview"
          maximize={this.props.maximize}
          onClick={this.props.handleClick}
        />
        <div
          id="preview"
          dangerouslySetInnerHTML={{ __html: this.props.htmlContent }}
        />
      </div>
    );
  }
}

class TitleBar extends Component {
  render() {
    const style = {
      position: 'relative',
      paddingLeft: 10,
      paddingRight: 10,
      width: '100%',
      height: '40px',
      lineHeight: '40px',
      fontWeight: 700,
      backgroundColor: 'yellowgreen',
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5
    };

    const iconStyle = {
      float: 'right'
    };

    return (
      <div onClick={this.props.onClick} className="title-bar" style={style}>
        {this.props.title}
        <span style={iconStyle} className="icon">
          {this.props.maximize ? (
            <i className="fas fa-window-minimize" />
          ) : (
            <i className="far fa-window-maximize" />
          )}
        </span>
      </div>
    );
  }
}

function MainTitle(props) {
  const style = {
    textAlign: 'center'
  };
  return (
    <div style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="104"
        height="64"
        viewBox="0 0 208 128"
      >
        <rect
          width="198"
          height="118"
          x="5"
          y="5"
          ry="10"
          stroke="#444"
          strokeWidth="10"
          fill="none"
        />
        <path
          fill="#444"
          d="M30 98v-68h20l20 25 20-25h20v68h-20v-39l-20 25-20-25v39zM155 98l-30-33h20v-35h20v35h20z"
        />
      </svg>
      <h1>React Markdown Previewer</h1>
    </div>
  );
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: defaultMarkdown,
      editorMaximized: false,
      previewerMaximized: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleComponentClick = this.handleComponentClick.bind(this);
  }

  handleChange(textInput) {
    this.setState({
      input: textInput
    });
  }

  handleComponentClick(component) {
    this.setState({
      [`${component}Maximized`]: !this.state[`${component}Maximized`]
    });
  }

  render() {
    return (
      <div className="container">
        <MainTitle />
        <Editor
          handleChange={this.handleChange}
          handleClick={() => this.handleComponentClick('editor')}
          input={this.state.input}
          maximize={this.state.editorMaximized}
        />
        {this.state.input.length > 0 &&
          !this.state.editorMaximized && (
            <Previewer
              htmlContent={marked(this.state.input, { renderer: renderer })}
              maximize={this.state.previewerMaximized}
              handleClick={() => this.handleComponentClick('previewer')}
            />
          )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js